import React, { useState, useEffect, useContext } from "react";
import { Grid, Typography } from "@material-ui/core/";
import { EWContext } from "../../context/EWContext";
import StepperNavigationButtons from "../StepperNavigationButtons/StepperNavigationButtons";
import SummarySavings from "./SummarySavings/SummarySavings";
import SummaryContent from "./SummaryContent/SummaryContent";
import { orderGroupsByElementAsc, getContactError } from "../../utils/utils";
import { receiptSavingService } from "../../services/services";
import withErrorHandler from "../../hoc/withErrorHandler/withErrorHandler";
import ScheduleAppointmentSummary from "./ScheduleAppointmentSummary/ScheduleAppointmentSummary";

function EligibilitySummary({ handleNext, handleBack, group }) {
    const [accountState, setAccountState] = useContext(EWContext);
    const [loading, setLoading] = useState(false);
    const [savingsResponse, setSavingsResponse] = useState({});
    const {
        answers,
        sectionsAnswers,
        selectedDocumentsValues,
        productInfo,
        groups,
        baseUrl,
        callSavingsService,
        customErrors,
        pimcore,
        storeContact,
        version,
        rebatesMessage,
        zeroRebatesEndMessage,
        conditionSpecificBehaviors
    } = accountState;

    const { productAnwersMergeCheck, buttonNameOnSummary } = conditionSpecificBehaviors ? conditionSpecificBehaviors : false;
    const finalAnswersForMerge= [];

    const [errorInForm, setErrorInForm] = useState({
        message: customErrors.genericError,
        genericMessage: customErrors.contactError,
        labelButton: "Back",
        error: false
    });

    const displayError = (error, secondaryMessage) => {
        const errorMessage = error?.message || error;
        setLoading(false);
        setErrorInForm(prev => {
            return {
                ...prev,
                ...{
                    message: errorMessage || customErrors.genericError,
                    genericMessage: secondaryMessage || '',
                    error: true
                }
            }
        })
    };

    useEffect(() => {
        if (errorInForm.error) {
            setAccountState((prevAccountState) => ({
                ...prevAccountState,
                ...{
                    submitAttempts: prevAccountState.submitAttempts + 1,
                    eligibilityError: errorInForm,
                },
            }));
        }
    }, [errorInForm, setAccountState]);

    /**Merging the steps answers on the basis of groupQuestions object from config  */
    useEffect(() => {
        if(productAnwersMergeCheck){
        groups.forEach((groupQuestions)=>{
            if(groupQuestions.id === "ahri" && groupQuestions.pageMergeCheck === true){
                const groupQuestionsAnwsers = Object.values(groupQuestions.pagesMergeForAllAnswer);
                groupQuestionsAnwsers.forEach(element => {
                    finalAnswersForMerge.push(answers[element])
                });
            }
        })
      }
    }, []);// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (callSavingsService?.flag) {
            // Using an IIFE
            (async function callingService() {
                const conditionBasedSavingPayload = productAnwersMergeCheck ? finalAnswersForMerge.flat() : answers[callSavingsService.answers]
                setLoading(true);
                try {
                    const savingsResponse = await receiptSavingService(
                        conditionBasedSavingPayload,
                        baseUrl,
                        customErrors.genericError,
                        pimcore.measureId,
                        pimcore.productId,
                        accountState
                    );
                    if (savingsResponse[0] && Object.keys(savingsResponse[0]).length > 0) {
                        setSavingsResponse(savingsResponse);
                        setAccountState((prevAccountState) => ({
                            ...prevAccountState,
                            ...{
                                savingsDataResponse: savingsResponse,
                            },
                        }));
                        setLoading(false);
                    } else {
                        displayError(customErrors.savingsServiceFailError ? customErrors.savingsServiceFailError : getContactError(storeContact));
                    }
                } catch (error) {
                    console.log(error);
                    if(conditionSpecificBehaviors?.hidePimcoreApiErrorMessage) {
                        setSavingsResponse(error);
                        setAccountState((prevAccountState) => ({
                            ...prevAccountState,
                            ...{
                                savingsDataResponse: savingsResponse,
                            },
                        }));
                        setLoading(false);
                        
                    } else{
                        displayError(customErrors.savingsServiceFailError ? customErrors.savingsServiceFailError : getContactError(storeContact));
                    }
                }
            })();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onlyTandc = answers.eligibility ? answers.eligibility.every(
        (answer) => answer.type === "tandc"
    ) : false;

    const onlyshowOnSummary = answers.eligibility ? answers.eligibility.every(
        (answer) => answer.showOnSummary === true
    ) : false;

    let answersObj = {
        ...answers,
        upload: selectedDocumentsValues,
        review: null
    };

    groups.forEach((group) => {
        if (group.hideOnSummary) {
            answersObj[group.id] = null;
        }
        if (group.id === "validate" && (version === 2 || version === "2")) {
            if (group.hideOnSummary === false) {
                answersObj[group.id] = answers.validate;
            } else {
                answersObj[group.id] = null;
            }
        }
    });

    return (
        <Grid container spacing={3}>
            {
                answers.schedule && productInfo?.inventoryService === "service"
                ? <ScheduleAppointmentSummary handleNext={handleNext} handleBack={handleBack} />
                : (
                    <>
                        <Typography
                            variant="h4"
                            gutterBottom
                            style={{ margin: "35px 0 35px 15px" }}
                        >
                            { group.instructions || "Review the information below."}
                        </Typography>
                        <SummarySavings
                            receiptData={savingsResponse}
                            rebatesMessage={rebatesMessage}
                            zeroRebatesEndMessage={zeroRebatesEndMessage}
                            accountState = {accountState}
                        />
                        {orderGroupsByElementAsc([...groups], "summaryOrder").map((step, i) => {
                            if (i < groups.length - 1) {
                                if (
                                    step.id === "eligibility" &&
                                    onlyTandc &&
                                    !onlyshowOnSummary
                                ) {
                                    return null;
                                } else {
                                    if (answersObj[step.id]) {
                                        return (
                                            <SummaryContent
                                                answers={answersObj?.[step.id]}
                                                sections={sectionsAnswers?.[step.id]}
                                                title={step.summaryLabel || step.label}
                                                key={step.id}
                                            />
                                        );
                                    } else {
                                        return null;
                                    }
                                }
                            } else {
                                return null;
                            }
                        })}
                        <StepperNavigationButtons
                            handleBack={handleBack}
                            handleNext={handleNext}
                            loading={loading}
                            buttonNameOnSummary = { buttonNameOnSummary || false }
                        />
                    </>
                )
            }
        </Grid>
    );
}

export default withErrorHandler(EligibilitySummary);
